module.exports = __webpack_public_path__ + "static/media/yes.ad7a7db2.svg";